import React, {Component} from 'react'
import {addContact} from '../../api/ShopsApi'
import {StyleSheet, Modal, Image, TextInput, TouchableOpacity, View, ScrollView, Picker} from 'react-native'
import {Button, Text} from 'react-native-elements'
import {widthPercentageToDP as wp, heightPercentageToDP as hp} from 'react-native-responsive-screen'
import {percWidth, percHeight} from '../../api/StyleFuncs'
import {orderFormStyles} from './ContainerForm'
import logo from '../../../assets/midasRed.png'

 



export default class OrderForm extends Component{
    constructor(props){
        super(props)
        this.basket = []
        this.state = {
            type: "",
            
            disableSubmit: true,
            
        }
    }

    onOrderUploaded = () => {
    console.log('order uploaded')
    /*
    //OPEN UP A CONFIRMATION MODAL
    */
  }


  componentDidMount = async () =>{

    this.checkValidity()
    
  }

onSubmitEmail = async() => {
    
      // create reusable transporter object using the default SMTP transport
  let transporter = nodemailer.createTransport({
    host: "smtp.gmail.com",
    port: 465,
    secure: true, // true for 465, false for other ports
    auth: {
      user: "omi.midas@gmail.com", // generated ethereal user
      pass: "Ribbon111", // generated ethereal password
    },
  });

  // send mail with defined transport object
  let info = await transporter.sendMail({
    from: "omi.midas@gmail.com", // sender address
    to: "oyejr@hotmail.com", // list of receivers
    subject: "Hello ✔", // Subject line
    text: "Hello world?", // plain text body
    html: "<b>Hello world?</b>", // html body
  });

  console.log("Message sent: %s", info.messageId);
  // Message sent: <b658f8ca-6296-ccf4-8306-87d57a0b4321@example.com>

  // Preview only available when sending through an Ethereal account
  console.log("Preview URL: %s", nodemailer.getTestMessageUrl(info));
  // Preview URL: https://ethereal.email/message/WaQKMgKddxQDoou...

}


  
  

  


  
  

   
    

    onProductUploaded = () =>{
      console.log('product stock updated')
      
    }


    asyncForEach = async (array, callback) => {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    } 


    onClickSubmit = async () => {
      
      try{
        const {navigation} = this.props
        navigation.navigate(
          this.state.type,
          {order: this.state}
        )

      } catch (error) {
        console.warn(error)
        alert('Error: please try again or restart')
      }


     /*
      navigation.navigate(
        'Order Complete',
        {order: this.state}
      )
      */
    }

 
    


    checkValidity = async () => {
      this.state.disableSubmit = false

      if (this.state.type === ""){
        this.state.disableSubmit = true
      }
      
      

      this.setState({forceRefresh: Math.floor(Math.random() * 100000000)})
      console.warn(this.state.disableSubmit)

    }
    


    render(){
        return(
            <ScrollView style = {orderFormStyles.regForm}>
                <View style = {{marginBottom: 100}}>
                <Image source = {logo} style = {orderFormStyles.modalPic} />
                <Text style = {orderFormStyles.headerCenter} >MIDAS REQUESTS PORTAL</Text>
                

            
                <Text style = {orderFormStyles.subHeader} >Select an Application Type</Text>  
                <Picker
                  selectedValue={this.state.type}
                  style = {this.state.type !== ""? orderFormStyles.picker: orderFormStyles.pickerBad}
                  onValueChange={(itemValue, itemIndex) => {
                    this.setState({ type: itemValue })
                    setTimeout(()=>this.checkValidity(),500)
                  }}>
                  <Picker.Item label="Air Freight" value="Contact Form" />
                  <Picker.Item label="Container" value="Container Form" />
                  <Picker.Item label="RORO" value="RORO Form" />
                  <Picker.Item label="" value="" />
                </Picker>
             

                
                 <TouchableOpacity 
                  disabled = {this.state.disableSubmit}
                  style = {this.state.disableSubmit === false? orderFormStyles.modalButton: orderFormStyles.modalDisabledButton}
                  onPress = {() => this.onClickSubmit()}>
                  <Text style = {orderFormStyles.buttonText}>SUBMIT</Text>
                </TouchableOpacity>

                </View>

               

                
            </ScrollView>
      
        )
    }
  }



  